<template>
  <div id="app">
    <div class="apply_for">
      <div class="main">
        <div>
          <div class="main_top">
            <div class="top_left">
              <div class="main_left_top">企业信息填报</div>
              <div class="main_left_bottom">需要填写企业名称、地址、营业执照号码、法定代表人信息、提供企业的营业执照号码或注册号码，以便核实企业的合法性和身份。</div>
            </div>
            <div class="top_right">
              <el-image class="image_right" src="/img/ewdic.png"></el-image>
            </div>
          </div>
        </div>
        <div>
          <el-button type="primary" class="top_button" @click="btnIndex">企业信息填报→</el-button>
        </div>
      </div>
    </div>
    <div class="apply_for_list">
      <div class="main">
        <div>
          <div class="main_top">
            <div class="top_left">
              <div class="main_left_top">查询填报审核状态</div>
              <div class="main_left_bottom">利用我们的实时查询功能，轻松了解您的填报审核进度。不再盲目等待，一切尽在掌握！</div>
            </div>
            <div class="top_right">
              <el-image class="image_right" src="/img/serimg.png"></el-image>
            </div>
          </div>
        </div>
        <div>
          <el-button type="primary" class="top_button" @click="btnTaxat">查询填报审核状态→</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
  methods: {
    btnIndex() {
		this.$router.push({
		    path: "/index",
		});
    },
    btnTaxat() {
      this.$router.push({
		    path: "/login",
		});
    },
  },
};
</script>

<style scoped>
/* 设置中间两个 div 居中 */
#app {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* 设置 div 的宽高和边距 */
.apply_for,
.apply_for_list {
  width: 500px;
  height: 350px;
  margin: 50px 0;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.main {
  width: 70%;
  text-align: center;
}

.main_top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.main_left_top {
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  padding-bottom: 5px;
}

.main_left_bottom {
  font-size: 18px;
  text-align: left;
  font-weight: bold;
}

.image_right {
  width: 100px;
  height: 100px;
}

.top_button {
  margin-top: 50px;
  width: 70%;
  background-color: #169bd5;
}
</style>
